/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: inherit;
  }
`

export default class HomeIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="48.826" height="48.831" viewBox="0 0 48.826 48.831" css={Color}>
          <g id="그룹_4684" data-name="그룹 4684" transform="translate(13260.001 12471.1)">
            <path id="home_1_" data-name="home (1)" d="M47.514,21.239l0,0L27.591,1.317a4.494,4.494,0,0,0-6.358,0L1.325,21.225l-.02.02A4.493,4.493,0,0,0,4.3,28.9q.069.007.139.007h.794V43.57a5.267,5.267,0,0,0,5.262,5.261H38.335A5.267,5.267,0,0,0,43.6,43.57V28.911h.736a4.5,4.5,0,0,0,3.181-7.672Zm0,0" transform="translate(-13260 -12471.1)" fill="#fc0" />
            <path id="패스_4649" className="dark" data-name="패스 4649" d="M24.96-23.1H15.75v-2.16H11.79v2.16H2.46v2.97h22.5ZM8.07-2.85H19.38V-.66H8.07ZM4.2,2.25H23.28V-5.76H4.2ZM8.76-15.51c0-.9,1.59-1.26,5.01-1.26,3.45,0,5.01.36,5.01,1.26s-1.56,1.29-5.01,1.29C10.35-14.22,8.76-14.61,8.76-15.51Zm6.99,5.25v-1.38c4.68-.27,7.29-1.56,7.29-3.87,0-2.61-3.33-3.93-9.27-3.93-5.91,0-9.24,1.32-9.24,3.93,0,2.31,2.61,3.6,7.26,3.87v1.38H1.26V-7.2H26.28v-3.06Z" transform="translate(-13249 -12431)" fill="#1c202b" />
          </g>
        </svg>
      </Fragment>
    )
  }
}
